import { http } from "./config";
import authHeader from "./auth-header";

export default {
  // Buscar todos os tickets de carnê
  getAll() {
    return http.get("/api/tickets-carne", {
      headers: authHeader(),
    });
  },

  // Buscar ticket por ID
  getById(id) {
    return http.get(`/api/tickets-carne/${id}`, {
      headers: authHeader(),
    });
  },

  // Atualizar ticket
  update(id, ticketDTO) {
    return http.put(`/api/tickets-carne/${id}`, ticketDTO, {
      headers: authHeader(),
    });
  },

  // Buscar tickets por período
  getByPeriodo(dataInicio, dataFim, empresa) {
    return http.get("/api/tickets-carne/periodo", {
      headers: authHeader(),
      params: {
        dataInicio,
        dataFim,
        empresa,
      },
    });
  },

  exportar_fluxo_entrega_xls(params = {}) {
    return http.get("/api/tickets-carne/tickets-xls", {
      headers: authHeader(),
      params,
      responseType: "blob",
    });
  },

  // Buscar indicadores por período
  getIndicadores(dataInicio, dataFim, empresa) {
    return http.get("/api/tickets-carne/indicadores", {
      headers: authHeader(),
      params: {
        dataInicio,
        dataFim,
        empresa,
      },
    });
  },

  // Buscar as etapas
  getAllEtapas() {
    return http.get("/api/tickets-carne/etapas", {
      headers: authHeader(),
    });
  },

  // Catálogo de atividades
  getAtividadesCarne() {
    return http.get("/api/tickets-carne/atividades", {
      headers: authHeader(),
    });
  },

  // Atividades por etapa
  getAllEtapaAtividades() {
    return http.get("/api/tickets-carne/etapa-atividades", {
      headers: authHeader(),
    });
  },

  getEtapaAtividadeById(id) {
    return http.get(`/api/tickets-carne/etapa-atividades/${id}`, {
      headers: authHeader(),
    });
  },

  getEtapaAtividadesByTicketEtapaId(ticketCarneEtapaId) {
    return http.get(
      `/api/tickets-carne/etapa-atividades/ticket-etapa/${ticketCarneEtapaId}`,
      {
        headers: authHeader(),
      }
    );
  },

  createEtapaAtividade(dto) {
    return http.post("/api/tickets-carne/etapa-atividades", dto, {
      headers: authHeader(),
    });
  },

  updateEtapaAtividade(id, dto) {
    return http.put(`/api/tickets-carne/etapa-atividades/${id}`, dto, {
      headers: authHeader(),
    });
  },

  deleteEtapaAtividade(id) {
    return http.delete(`/api/tickets-carne/etapa-atividades/${id}`, {
      headers: authHeader(),
    });
  },
};
